"use client";

import { tagsLoadInThisEnv } from "@/lib/consent/region";
import { useAnalyticsAllowed } from "@/store/consentStore";
import Script from "next/script";

// Cede Hub GA4 measurement ID and GTM container (public, fixed to the properties).
const GA_MEASUREMENT_ID = "G-97CLTKE39N";
const GTM_CONTAINER_ID = "GTM-MPDPQKT6";

/**
 * The analytics and advertising tags, mounted only once the visitor has allowed
 * them.
 *
 * Nothing is loaded and suppressed: Google's consent mode still fetches
 * third-party code and hands over the visitor's IP, which is the part
 * regulators object to. Rendering nothing means nothing is contacted.
 *
 * The GTM `<noscript>` iframe that used to sit beside these is deliberately
 * gone: it fires for visitors with JavaScript off, who never see a banner and
 * so can never be asked, which makes it impossible to gate.
 */
export function ConsentedTags() {
  const allowed = useAnalyticsAllowed();

  if (!tagsLoadInThisEnv() || !allowed) return null;

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');
        `}
      </Script>
    </>
  );
}
